import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import Select from 'react-select';
import { OperationKeyValues } from '../constants/OperationKeyValues';
import dateUtils from './utilities/DateUtilities';
import dateTimeFilter from '../constants/DateTimeFilter';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import {
    addDays,
    subDays,
    endOfDay,
    startOfDay,
    startOfMonth,
    endOfMonth,
    addMonths,
    startOfWeek,
    endOfWeek,
    isSameDay,
    differenceInCalendarDays,
    addYears,
    startOfYear,
    endOfYear,
} from 'date-fns';
import DateFilterCalendar from './DateFilterCalendar';

const FilterScreen = (props) => {

    const [selectOperator, setSelectOperator] = useState([]);
    const [customRangesOperator, setCustomRangesOperator] = useState({
        operation: "",
        operationKeyValue: "",
        value: "",
        columnType: "",
        showCalendar: false,
    })
    const [selectedDateOptionIs, setSelectedDateOptionIs] = useState("")
    const [selectedDateOperatorIs, setSelectedDateOperatorIs] = useState("")
    const [dateRangesData, setDateRangesData] = useState("")
    const [dateTimeFilterArray, setDateTimeFilterArray] = useState([])
    const [filterArray, setFilterArray] = useState([]);
    const [filterValues, setFilterValues] = useState({
        name: "",
        operation: "",
        operationKeyValue: "",
        value: "",
    });

    const dateOptions = [
        { label: 'Today', value: `${startOfDay(new Date())}#${endOfDay(new Date())}` },
        { label: 'Yesterday', value: `${startOfDay(addDays(new Date(), -1))}#${endOfDay(addDays(new Date(), -1))}` },
        { label: 'This Week', value: `${startOfWeek(new Date())}#${endOfWeek(new Date())}` },
        { label: 'Last Week', value: `${startOfWeek(addDays(new Date(), -7))}#${endOfWeek(addDays(new Date(), -7))}` },
        { label: 'Last Two Weeks', value: `${startOfWeek(addDays(new Date(), -14))}#${endOfWeek(addDays(new Date(), -7))}` },
        { label: 'This Month', value: `${startOfMonth(new Date())}#${endOfMonth(new Date())}` },
        { label: 'Last Month', value: `${startOfMonth(addMonths(new Date(), -1))}#${endOfMonth(addMonths(new Date(), -1))}` },
        { label: 'Last Two Months', value: `${startOfMonth(addMonths(new Date(), -2))}#${endOfMonth(addMonths(new Date(), -1))}` },
    ]

    const predefineStaticRange = [
        {
            label: 'Today',
            range: () => ({
                startDate: startOfDay(new Date()),
                endDate: endOfDay(new Date()),
            }),
            isSelected(range) {
                const definedRange = this.range();
                return (
                    isSameDay(range.startDate, definedRange.startDate) &&
                    isSameDay(range.endDate, definedRange.endDate)
                );
            }
        },
        {
            label: 'Yesterday',
            range: () => ({
                startDate: startOfDay(addDays(new Date(), -1)),
                endDate: endOfDay(addDays(new Date(), -1)),
            }),
            isSelected(range) {
                const definedRange = this.range();
                return (
                    isSameDay(range.startDate, definedRange.startDate) &&
                    isSameDay(range.endDate, definedRange.endDate)
                );
            }
        },
        {
            label: 'This Week',
            range: () => ({
                startDate: startOfWeek(new Date()),
                endDate: endOfWeek(new Date()),
            }),
            isSelected(range) {
                const definedRange = this.range();
                return (
                    isSameDay(range.startDate, definedRange.startDate) &&
                    isSameDay(range.endDate, definedRange.endDate)
                );
            }
        },
        {
            label: 'Last Week',
            range: () => ({
                startDate: startOfWeek(addDays(new Date(), -7)),
                endDate: endOfWeek(addDays(new Date(), -7)),
            }),
            isSelected(range) {
                const definedRange = this.range();
                return (
                    isSameDay(range.startDate, definedRange.startDate) &&
                    isSameDay(range.endDate, definedRange.endDate)
                );
            }
        },
        {
            label: 'Past Two Weeks',
            range: () => ({
                startDate: startOfWeek(addDays(new Date(), -14)),
                endDate: endOfWeek(addDays(new Date(), -7)),
            }),
            isSelected(range) {
                const definedRange = this.range();
                return (
                    isSameDay(range.startDate, definedRange.startDate) &&
                    isSameDay(range.endDate, definedRange.endDate)
                );
            }
        },
        {
            label: 'This Month',
            range: () => ({
                startDate: startOfMonth(new Date()),
                endDate: endOfMonth(new Date()),
            }),
            isSelected(range) {
                const definedRange = this.range();
                return (
                    isSameDay(range.startDate, definedRange.startDate) &&
                    isSameDay(range.endDate, definedRange.endDate)
                );
            }
        },
        {
            label: "Last Month",
            range: () => ({
                startDate: startOfMonth(addMonths(new Date(), -1)),
                endDate: endOfMonth(addMonths(new Date(), -1))
            }),
            isSelected(range) {
                const definedRange = this.range();
                return (
                    isSameDay(range.startDate, definedRange.startDate) &&
                    isSameDay(range.endDate, definedRange.endDate)
                );
            }
        },
        {
            label: "Before",
            range: () => ({
                startDate: startOfYear(new Date()),
                endDate: endOfDay(new Date())
            }),
            isSelected(range) {
                const definedRange = this.range();
                return (
                    isSameDay(range.startDate, definedRange.startDate) &&
                    isSameDay(range.endDate, definedRange.endDate)
                );
            }
        }
    ];

    useEffect(() => {
        if (props.sortTableDataIs.searchFilters.length !== 0) {
            setFilterArray(props.sortTableDataIs.searchFilters);
        }
        if (props.sortTableDataIs.searchFilters.length !== 0) {
            props.sortTableDataIs.searchFilters.map((data, i) => {
                if (data.columnName === props.columnData[0]) {
                    if (props.columnData[1] === "BOOLEAN") {
                        setFilterValues({
                            name: data.columnName,
                            value: data.columnValue,
                            operation: "EQUAL_TO",
                            operationKeyValue: "",
                        });
                    } else if (props.columnData[1] === "ENUM") {
                        setFilterValues({
                            name: data.columnName,
                            value: data.columnValue,
                            operation: data.columnValue,
                            operationKeyValue: "",
                        });
                    } else if ((props.columnData[1] === "STRING") || (props.columnData[1] === "COLLECTION_OBJECT") || (props.columnData[1] === "COLLECTION_OBJECT_LIST")) {
                        setFilterValues({
                            name: data.columnName,
                            value: data.columnValue,
                            operation: data.operation,
                            operationKeyValue: OperationKeyValues(props.columnData[1]).find(function (post, index) {
                                if (post.value === data.operation)
                                    return post;
                            }),
                        });
                    } else if ((props.columnData[1] === "DATE") || (props.columnData[1] === "DATETIME")) {
                        setFilterValues({
                            name: data.columnName,
                            value: data.columnValue,
                            operation: data.operation,
                            // operationKeyValue: OperationKeyValues(props.columnData[1]).find(function (post, index) {
                            //     if (post.value == data.operation)
                            //         return post;
                            // }),

                            operationKeyValue: OperationKeyValues(props.columnData[1]).find((post) =>
                                props.dateTimeFilterDataIs.searchFilters.find((newArr) => {
                                    if (newArr.operationKeyValue.label === post.label) {
                                        return newArr.operationKeyValue;
                                    }
                                })
                            ),
                        });
                        setSelectedDateOperatorIs(OperationKeyValues(props.columnData[1]).find((post) =>
                            props.dateTimeFilterDataIs.searchFilters.find((newArr) => {
                                if (newArr.operationKeyValue.label === post.label) {
                                    return newArr.operationKeyValue;
                                }
                            })
                        ))


                        var dateSelectedKeyValuePair = OperationKeyValues(props.columnData[1]).find((post) =>
                            props.dateTimeFilterDataIs.searchFilters.find((newArr) => {
                                if (newArr.operationKeyValue.label === post.label) {
                                    return newArr.operationKeyValue;
                                }
                            })
                        )
                        if (dateSelectedKeyValuePair.label === "After" || dateSelectedKeyValuePair.label === "Before") {
                            setCustomRangesOperator({
                                value: data.columnValue,
                                operation: dateSelectedKeyValuePair.value,
                                operationKeyValue: dateSelectedKeyValuePair,
                                columnType: props.columnData[1],
                                showCalendar: false
                            })
                        }
                    }
                }
            })
            if(props.columnData[1] === "ENUM"){
                let enumData = props.dynamicFormFields.find((data)=>data.name === props.columnData[0]).options ||"eytu,titryu,ryui,rtyui";
                let enumDataArray = enumData.split(",")
                setSelectOperator(enumDataArray.map((data)=>{
                    return {label:data,value:data}
                }))
            }else{
                setSelectOperator(OperationKeyValues(props.columnData[1]))
            }
        } else {
            if(props.columnData[1] === "ENUM"){
                let enumData = props.dynamicFormFields.find((data)=>data.name === props.columnData[0]).options ||"eytu,titryu,ryui,rtyui";
                let enumDataArray = enumData.split(",")
                setSelectOperator(enumDataArray.map((data)=>{
                    return {label:data,value:data}
                }))
            }else{
                setSelectOperator(OperationKeyValues(props.columnData[1]))
            }
        }


    }, [props]);

    // Apply Filter for Selected Columns
    const handleApplyFilter = () => {
        var _filterArray = [...filterArray];
        var _dateTimeFilterArray = [...dateTimeFilterArray];
        const found = _filterArray.some((data) => data.columnName === props.columnData[0]);
        const dateTimeArrDataFound = _dateTimeFilterArray.some((data) => data.columnName === props.columnData[0]);

        if (found) {
            _filterArray.splice(_filterArray.findIndex((data) => data.columnName === props.columnData[0]), 1, {
                columnName: props.columnData[0],
                columnType: props.columnData[1],
                columnValue: filterValues.value,
                operation: filterValues.operation
            });
        } else {
            _filterArray.push({
                columnName: props.columnData[0],
                columnType: props.columnData[1],
                columnValue: filterValues.value,
                operation: filterValues.operation
            });
        }

        if (dateTimeArrDataFound) {
            _dateTimeFilterArray.splice(_dateTimeFilterArray.findIndex((data) => data.columnName === props.columnData[0]), 1, {
                columnName: props.columnData[0],
                columnType: props.columnData[1],
                columnValue: filterValues.value,
                operation: filterValues.operation,
                operationKeyValue: filterValues.operationKeyValue
            });
        } else {
            _dateTimeFilterArray.push({
                columnName: props.columnData[0],
                columnType: props.columnData[1],
                columnValue: filterValues.value,
                operation: filterValues.operation,
                operationKeyValue: filterValues.operationKeyValue
            });
        }
        props.handleApplyFilter(_filterArray, props.columnData[0], true, _dateTimeFilterArray)
        // props.handleApplyFilter(_filterArray, props.columnData[0], filterValues.value, filterValues.operation, true)
    }

    // Cancel Filter for Selected Column
    const handleCancelFilter = () => {
        var _filterArray = [...filterArray];
        var _dateTimeFilterArray = [...dateTimeFilterArray];

        const found = _filterArray.some((data) => data.columnName === props.columnData[0]);
        const dateTimeArrDataFound = _dateTimeFilterArray.some((data) => data.columnName === props.columnData[0]);

        if (found) {
            _filterArray.splice(_filterArray.findIndex((data) => data.columnName === props.columnData[0]), 1);
        }
        if (dateTimeArrDataFound) {
            _dateTimeFilterArray.splice(_dateTimeFilterArray.findIndex((data) => data.columnName === props.columnData[0]), 1);
        }
        props.handleApplyFilter(_filterArray, props.columnData[0], false, _dateTimeFilterArray)
    }

    // handle Date Select 
    const handleCustomDateSelect = (e) => {
        setSelectedDateOperatorIs(e)
        if (e.label === "After" || e.label === "Before" || e.label === "Custom") {
            setCustomRangesOperator({
                // value: "",
                value: customRangesOperator?.value === "" ? new Date() : new Date(customRangesOperator?.value),
                operation: e.value,
                operationKeyValue: e,
                columnType: props.columnData[1],
                showCalendar: true
            })
            // setSelectedDateOptionIs(e.label)
        } else {
            setFilterValues({
                value: dateTimeFilter.convertFormattedDatTimeByTimeStamp(e.label, props.columnData[1]),
                operation: e.value,
                name: props.columnData[0],
                // operationKeyValue: "",
                operationKeyValue: e,
            })
        }
    }

    // handle Select custom Date Range 
    const handleSelectDateRange = (dateValue) => {
        setFilterValues({
            value: dateValue,
            operation: customRangesOperator.operation,
            name: props.columnData[0],
            operationKeyValue: customRangesOperator.operationKeyValue,
        });
        setCustomRangesOperator({
            operation: "",
            operationKeyValue: "",
            value: dateValue,
            // columnType: "",
            columnType: customRangesOperator.columnType,
            showCalendar: false,
        });
    }

    // Show Custom Range Calendar 
    const callCustomRangeCalendar = () => {
        return (
            <DateFilterCalendar
                setSelectedDateOptionIs={setSelectedDateOptionIs}
                setDateRangesData={setDateRangesData}
                customRangesOperator={customRangesOperator}
                setCustomRangesOperator={setCustomRangesOperator}
                handleSelectedDateRange={handleSelectDateRange}
                filterType={selectedDateOperatorIs?.label === "Custom" ? "free-range" : "single"}
            />
        );
    }

    return (
        <>
            {(props.columnData[1] === "DATETIME") ?
                <>
                    <Select
                        options={selectOperator}
                        value={selectedDateOperatorIs}
                        id="type"
                        placeholder="Select Filter"
                        // className='filter-select'
                        onChange={handleCustomDateSelect}
                        styles={{ overflowY: "scroll !important" }}
                        className="react-select-container"
                    />
                    {customRangesOperator?.showCalendar &&
                        callCustomRangeCalendar()}
                    {customRangesOperator?.value !== "" && props.columnData[1] === "DATE" &&
                        <p>{dateUtils.getCalendarFormattedDateByTimeStamp(customRangesOperator?.value)}</p>}


                    {customRangesOperator?.value !== "" && props.columnData[1] === "DATETIME" &&
                        <p>{dateUtils.getFormattedDateTimeForDateTimeColumns(customRangesOperator?.value)}</p>}
                </>
                :
                (props.columnData[1] === "BOOLEAN") ?
                    <>
                        <div className="row mb-1">
                            <div className="col-lg-12">
                                <input type="checkbox" className="input-default"
                                    id="active"
                                    onChange={(e) => setFilterValues({
                                        ...filterValues,
                                        value: e.target.checked,
                                        operation: "EQUAL_TO",
                                        name: props.columnData[0]
                                    })}
                                    checked={filterValues.value === true ? true : false}
                                />
                                <label className='ms-2'>Active</label>
                            </div>
                        </div>
                        <div className="row mb-1">
                            <div className="col-lg-12">
                                <input type="checkbox" className="input-default"
                                    id="Inactive"
                                    // placeholder='value'
                                    onChange={(e) => setFilterValues({
                                        ...filterValues,
                                        value: !e.target.checked,
                                        operation: "EQUAL_TO",
                                        name: props.columnData[0],

                                    })}
                                    checked={filterValues.value === false ? true : false}
                                />
                                <label className='ms-2'>InActive</label>
                            </div>
                        </div>
                    </> :
                    (props.columnData[1] === "ENUM") ?
                        <Select
                            options={selectOperator}
                            value={filterValues.operation}
                            id="type"
                            placeholder="Select ENUM Value"
                            // className='filter-select'
                            onChange={(e) => setFilterValues({
                                ...filterValues,
                                operation: e,
                                operationKeyValue: e,
                            })}
                            styles={{ overflowY: "auto !important",marginBottom:"10px" }}
                            className="react-select-container"
                        />
                    :
                    <>
                        <Select
                            options={selectOperator}
                            value={filterValues.operationKeyValue}
                            id="type"
                            placeholder="Select Filter"
                            // className='filter-select'
                            onChange={(e) => setFilterValues({
                                ...filterValues,
                                operation: e.value,
                                operationKeyValue: e,
                            })}
                            styles={{ overflowY: "auto !important" }}
                            className="react-select-container"
                        />
                        <div className="mb-1 mt-2">
                            <input type="text" className="form-control input-default"
                                id="name"
                                placeholder='value'
                                onChange={(e) => setFilterValues({
                                    ...filterValues,
                                    value: e.target.value,
                                    // name: e.target.value,
                                })}
                                value={filterValues.value}
                            />
                        </div>
                    </>
            }
            <div className=" row mb-1">
                <div className="d-flex justify-content-between">
                    <Button className="filter-btn" onClick={handleApplyFilter}>Filter</Button>
                    <Button className="filter-cancel-btn" onClick={handleCancelFilter}>Cancel</Button>
                </div>
            </div>
        </>
    )
}

export default FilterScreen